// extracted by mini-css-extract-plugin
module.exports = {"sub_title":"sub_title-IKgptzFW"};